import logoDTA from "@assets/events-awards/logo-dta.png";
import { BlockTitle } from "@blocks/Blocks";

/**
 * Component to render DTA about page
 */
const DTAAboutPage = (): React.ReactElement => {
  return (
    <div
      data-testid="dta-about-page-component"
      className="pb-6 font-public-sans leading-[1.4]"
    >
      <BlockTitle
        text="About"
        rootClassName="py-3 pb-1 text-4xl md:text-6xl lg:text-8xl font-medium font-poppins"
      />

      <p>
        The Design AI and Tech Awards celebrates innovation across all types of
        enterprises — from startups and SMEs to large corporations — that
        harness design and technology to create impactful solutions for
        real-world business challenges.
      </p>

      <p>
        The awards will honour outstanding achievements by businesses of all
        sizes and sectors, grouped into two categories:
      </p>

      <ul className="mb-6 list-outside list-none">
        <li>1. Start-ups and SMEs</li>
        <li>2. Large Corporations</li>
      </ul>

      <p className="mb-3">
        Outstanding entries from each category will be shortlisted to present
        their ideas at a dedicated event, with up to three top prizes awarded
        per category — ensuring that impactful solutions, regardless of scale,
        receive the spotlight they deserve.
      </p>

      <div className="-ml-3">
        <img
          src={logoDTA}
          alt="Singapore Business Awards logo"
          width={246}
          height={132}
        />
      </div>

      <BlockTitle
        text="Objective"
        rootClassName="-mt-1 pb-1 text-4xl font-bold font-public-sans md:text-6xl lg:text-8xl"
      />

      <p>
        To inspire and drive innovation across all enterprises by challenging
        them to harness design and technology in developing solutions that
        address real-world business challenges. Through a rigorous and holistic
        evaluation process, the Design AI and Tech Awards aims to recognise and
        celebrate the most innovative enterprises, setting a benchmark that
        encourages others to foster a culture of continuous innovation within
        their organisations.
      </p>
    </div>
  );
};

export default DTAAboutPage;
